import { defineStore } from 'pinia';
import { randomNumber } from '@/utils';
import type { ToastLinkModel, ToastModel } from '@/models';

interface ToastState {
  toasts: ToastModel[];
}

export const useToastStore = defineStore('toasts', {
  state: (): ToastState => {
    return {
      toasts: [],
    };
  },

  actions: {
    addSuccessToast(title: string, message: string, actionLink?: ToastLinkModel) {
      this.addToast({
        variant: 'success',
        title,
        message,
        actionLink: actionLink,
      });
    },

    addErrorToast(title: string, message: string) {
      this.addToast({
        variant: 'error',
        title,
        message,
      });
    },

    addToast(toast: ToastModel) {
      toast.key = `${randomNumber(100, 1000)}_${toast.variant}`;

      this.toasts = [toast, ...this.toasts];

      let timeout = toast.timeout;
      if (!timeout) {
        timeout = toast.actionLink ? 5000 : 3000; // If an actionLink is defined, keep notif open longer
      }

      setTimeout(() => {
        this.removeToast(toast);
      }, timeout);
    },

    removeToast(toast: ToastModel) {
      this.toasts = this.toasts.filter(x => x.key !== toast.key);
    },
  },
});
